/**
 * @fileoverview AR-805 — single kill-switch for every Classroom surface.
 * Arc-only AND gated on the school-scoped `arc-google-classroom` flag, which
 * /api/arc_mosaico/features/current serves from the school's own features.
 *
 * The flag is off by default: a school sees nothing about Classroom until a
 * super admin grants it on /admin/feature-flags. The matching global Flipper
 * flag exists only so that screen has a checkbox to offer — the backend keeps
 * `arc-google-classroom` in SCHOOL_SCOPED_FEATURES so the global entry can
 * never grant the feature by itself.
 */

import { useFeatureToggle, useFeatureToggleLoading } from 'hooks'

export const CLASSROOM_FEATURE_FLAG = 'arc-google-classroom'

export function useClassroomIntegrationEnabled(): { enabled: boolean; loading: boolean } {
  const isArc = useFeatureToggle('arc-mosaico-project') as boolean
  const hasClassroomFlag = useFeatureToggle(CLASSROOM_FEATURE_FLAG) as boolean
  const loading = useFeatureToggleLoading()

  return { enabled: Boolean(isArc && hasClassroomFlag), loading }
}
